<template>
  <div>
    <div class="trigger" @click="openDropDown()">
      <slot></slot>
    </div>
    <div v-if="droppedDown">
      <div class="background" @click="closeDropDown()">
        <div>
          <div class="dropdown" @click.stop="swallowClick">
            <div class="content">
              <div class="exit" @click="closeDropDown()">
                <Fai :icon="['fas', 'times']"/>
              </div>
              <div>
                <div v-for="(navObj, i) in routes" :key="i">
                  <div class="link-row">
                    <div>
                      <div @click="closeDropDown()" class="nav-link-router-link-container">
                        <router-link :to="navObj.route">{{navObj.ui.name}}</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="search-row">
                <form class="pure-form" @submit.prevent="handleSubmit">
                  <div class="search-form-section">
                    <input type="text" placeholder="Search" autofocus>
                    <button type="submit" class="pure-button flat-button">
                      <Fai :icon="['far', 'search']"/>
                    </button>
                  </div>
                </form>
              </div>
              <div class="download-our-app-row">
                <div class="download-our-app">
                  <span>DOWNLOAD OUR APP</span>
                </div>
                <div class="download-images">
                  <a :href="googlePlaystoreLink">
                    <div class="store-link-img-container">
                      <img src="../../assets/images/google-play.png" alt="Google Play">
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {loggerMixin} from '../../mixins/logger'
  import {
    GET_NAV_ROUTES,
  } from '../../services/constants'

  export default {
    name: 'HeaderMobileDropdown',
    mixins: [loggerMixin],
    data() {
      return {
        showState: false,
      }
    },
    computed: {
      ...mapGetters([
        GET_NAV_ROUTES,
      ]),
      routes() {
        return this[GET_NAV_ROUTES]
      },
      droppedDown() {
        return this.showState
      },
      googlePlaystoreLink(){
        return "https://play.google.com/store/apps/details?id=net.ideamap.android"
      }
    },
    methods: {
      openDropDown() {
        this.showState = true
      },
      closeDropDown() {
        this.showState = false
      },
      swallowClick() {

      },
      handleSubmit() {
        this.closeDropDown()
        this.log('handleSubmit mock')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .background {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  .dropdown {
    display: inline-block;
    position: relative;
    width: 250px;
    background-color: $cyan-blue-3;
    color: white;
    font-size: 16px;
    font-weight: lighter;
    box-shadow: $cyan-blue-3 0 2px 4px 0;
  }

  .content {
    padding: 1em 0;
  }

  .exit {
    font-size: 2em;
    padding: 0 .5em;
    margin: 0 0 1em 0;
  }

  .link-row {
    padding: 1em 1em 1em 2em;

    &:not(.last) {
      border-bottom: solid $white-1 1px;
    }
  }

  .search-row {
    padding: 1em 0;
    justify-content: flex-start;

    .flat-button {
      color: $white-1;
    }

    .pure-form input[type="text"] {
      color: $cyan-blue-3;
    }

    .search-form-section {
      padding: 0 1em;
      display: flex;
      align-items: center;

      input {
        width: 100%;
      }
    }
  }

  .download-our-app-row {
    padding: 1em;

    .download-our-app {
      color: $red-2;
      font-weight: normal;

    }

    .download-images {
      text-align: center;

      .store-link-img-container {
        margin: 0 1em 0 0;
      }
    }
  }
</style>
